import { render, staticRenderFns } from "./Infobulle.vue?vue&type=template&id=4415b2a2"
import script from "./Infobulle.vue?vue&type=script&lang=js"
export * from "./Infobulle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports